import DayView from '../../pages/dayView/DayView'
import { DateStoreWrapper } from '../../contexts/DateStore'
import { DayStoreWrapper } from '../../contexts/DayStore'
import { RoomStoreWrapper } from '../../contexts/RoomsStore'
import { UsersStoreWrapper } from '../../contexts/UsersStore'
import AdditionalSalesSecretButton from './AdditionalSalesSecretButton'
import './AdditionalSalesView.css'
import { useEffect } from 'react'
import { ADDITIONAL_SALES_PLANNING_VIEW_TIMEOUT } from '../../utils/constantes'

const PlanningView = ({ changeView }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      changeView()
    }, ADDITIONAL_SALES_PLANNING_VIEW_TIMEOUT)
    return () => clearTimeout(timeout)
  }, [changeView])

  return (
    <>
      <DateStoreWrapper>
        <RoomStoreWrapper>
          <UsersStoreWrapper>
            <DayStoreWrapper>
              <DayView isFullscreen={true} />
            </DayStoreWrapper>
          </UsersStoreWrapper>
        </RoomStoreWrapper>
      </DateStoreWrapper>
      <AdditionalSalesSecretButton style={{ zIndex: 20 }} onClick={changeView} />
    </>
  )
}

export default PlanningView
